module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/ColorFill-6d2ecce84689dc6c1f497e3f87ba4576.svg";